import React from "react";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h1 style={styles.heading}>Dashboard</h1>

        <button style={styles.button} onClick={() => navigate("/upload")}>
          Upload Document
        </button>

        <button style={styles.button} onClick={() => navigate("/gallery")}>
          View Gallery
        </button>
      </div>
    </div>
  );
};

export default Dashboard;

const styles = {
  body: {
    background: "linear-gradient(to right, #0f2027, #203a43, #2c5364)",
    color: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    padding: "20px",
  },
  container: {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    padding: "40px",
    borderRadius: "20px",
    width: "90%",
    maxWidth: "500px",
    boxShadow: "0 0 20px rgba(255, 255, 255, 0.2)",
    textAlign: "center",
  },
  heading: {
    marginBottom: "30px",
    color: "#FFD700",
    fontSize: "36px",
  },
  button: {
    backgroundColor: "#FFD700",
    color: "#000",
    fontWeight: "bold",
    padding: "15px",
    border: "none",
    borderRadius: "12px",
    fontSize: "18px",
    cursor: "pointer",
    width: "100%",
    marginTop: "20px",
    transition: "background-color 0.3s ease",
  },
};
